import React from "react";

const Values = () => {
  return (
    <div>
      <h2 class="mt-35" style={{ backgroundColor: "#ff9100" }}>
        CORE VALUES
      </h2>
      <div class="row justify-content-center section-title mt-25">
        <div class="col-md ">
          <h2>1. Users First</h2>
          <p>
            Users are at the top of our minds. Users first, not “us” first. We
            are externally focused and want to exceed the expectations of
            end-users and our customers and make them say “Oh, this is what I
            really wanted!”.We solve for the customer ,not just for their
            happiness, but also their success
          </p>
        </div>

        <div class="col-md ">
          <h2>2. Integrity</h2>
          <p>
            We always act fairly towards colleagues, customers and
            partners.Every relationship and interaction is rooted in honesty.
            Our decisions are fair and equitable for all parties involved,we are
            open, ethical and straight.People trust us to adhere to our word.
          </p>
        </div>

        <div class="col-md ">
          <h2>3. Think Big</h2>
          <p>
            We think boldly.We don’t make excuses; instead, we think of positive
            and realistic ways to get things done.We do not think small for
            safe, risk-free accomplishments. We think extensively and come up
            with the ways to get things done, instead of finding excuses.
          </p>
        </div>
        <div class="row justify-content-center section-title mt-20">
          <div class="col-md ">
            <h2>4. Commitment</h2>
            <p>
              We never compromise;we are committed to deliver the end result. As
              professional business , we are determined to accomplish (without
              compromise) and never give up, even it takes extra time to do so.
            </p>
          </div>
          <div class="col-md ">
            <h2>5. Professionalism</h2>
            <p>
              In our company structure and traditions, Professionalism is seen
              in our dedication to professional growth.We want to achieve
              Akiltech Vision by pursuing uniqueness and high degree of
              professionalism, not by a broad and shallow approach.
            </p>
          </div>
          <div class="col-md ">
            <h2>6. Evolution</h2>
            <p>
              We continue to evolve with change.We are ever evolving; we should
              not be comfortable with status quo, we should learn from past
              mistakes and exceed our past success.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Values;
